import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';

export const CreatorAccelerator = ({ isLive }: { isLive: boolean }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!isLive) {
      setShowBanner(true);
      return;
    }
    const dismissed = !!localStorage.getItem('hideCreatorAcceleratorBanner');
    setShowBanner(!dismissed);
  }, []);

  if (!showBanner) return null;

  const dismiss = () => {
    localStorage.setItem('hideCreatorAcceleratorBanner', 'true');
    setShowBanner(false);
  };

  return (
    <div className="flex justify-between bg-[url('/static/images/home/coaching-apply-bg.png')] bg-no-repeat bg-cover rounded-[20px] p-8">
      <div className="flex flex-col gap-4">
        <Typography
          variant="display"
          size="small"
          className="text-[40px] text-white"
        >
          Hire a coach to setup and scale your business! 🚀
        </Typography>
        <Typography variant="title" className="text-white">
          Elevate your business with our coaching program
        </Typography>
        <a
          className="w-max mt-2"
          href="https://www.joinplaybook.com/get-coaching?utm_source=web+app"
          target="_blank"
          rel="noreferrer"
        >
          <div
            className={clsx(
              'flex gap-2 px-4 py-2 rounded-[10px]',
              sprinkles({ bg: 'W-100', color: 'B-100' }),
            )}
          >
            <Typography>Apply now</Typography>
          </div>
        </a>
      </div>
      {!isLive ? null : (
        <FontAwesomeIcon
          icon={faCircleXmark}
          className={clsx(
            sprinkles({ color: 'W-100/50' }),
            'w-8 h-8 cursor-pointer',
          )}
          onClick={dismiss}
        />
      )}
    </div>
  );
};
